import { SurveyQuestion } from './types';

/**
 * Board Director Follow-Up Survey
 *
 * Purpose: For board members who indicated they'd like to step back,
 * explore whether an advisory/emeritus role would work for them.
 *
 * Tone: Warm, appreciative, zero-pressure. Frame the advisory role
 * as a lighter-weight option that honours their contribution.
 *
 * Keep it short — 4 questions max so it feels respectful of their time.
 */
export const boardDirectorFollowupQuestions: SurveyQuestion[] = [

  // ── 1. Acknowledge & reframe ─────────────────────────────────────────────────
  {
    id: 'fu_advisory_interest',
    type: 'radio',
    label:
      'Thank you for your honest feedback in the earlier survey — I truly value it.\n\n' +
      'I completely understand wanting to step back from the formal board director role. ' +
      'At the same time, your presence, perspective, and reputation in the community mean a great deal to OARA.\n\n' +
      'Would you be open to staying connected as an Advisory Board Member? ' +
      'This is a lighter role — no formal responsibilities, no voting obligations, no deliverables. ' +
      'You would simply be someone I can reach out to for guidance when needed, and your name would continue to be associated with OARA.',
    required: true,
    options: [
      { value: 'yes_happy',    label: 'Yes — I would be happy to stay on in an advisory capacity' },
      { value: 'prefer_not',   label: 'I would prefer to step away entirely for now' },
      { value: 'unsure',       label: 'Not sure yet — let me think about it' },
    ],
  },

  // ── 2. Lightweight involvement preferences ──────────────────────────────────
  {
    id: 'fu_involvement_comfort',
    type: 'checkbox',
    label:
      'If you were to stay on as an advisor, which of these would you be comfortable with? (Select any that apply — all are optional)',
    required: false,
    options: [
      { value: 'attend_occasional',   label: 'Joining the 1-hour monthly board meeting when your schedule allows (no obligation)' },
      { value: 'email_consult',       label: 'Being available for occasional email or phone consultations' },
      { value: 'community_intros',    label: 'Making introductions to community contacts when opportunities arise' },
      { value: 'none',                label: 'None of these — I would prefer a fully passive role' },
    ],
  },

  // ── 3. Acknowledge revenue feedback ─────────────────────────────────────────
  {
    id: 'fu_revenue_thoughts',
    type: 'textarea',
    label:
      'You mentioned in your earlier feedback that OARA needs a clear revenue model — thank you for that, it is a great point. ' +
      'I am actively working on building one out. Just wanted to acknowledge that feedback and let you know it is being taken seriously.',
    required: false,
    placeholder: 'Optional — any thoughts you want to add...',
  },

  // ── 4. Open close ──────────────────────────────────────────────────────────
  {
    id: 'fu_anything_else',
    type: 'textarea',
    label: 'Any other comments?',
    required: false,
    placeholder: 'Optional — feel free to share anything at all...',
  },

];
